import { useState, useEffect } from 'react';

const DIAGNOSIS_URL = 'https://products-eight-sand.vercel.app/';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '課題', href: '#problem' },
    { label: '診断の流れ', href: '#flow' },
    { label: 'レポートサンプル', href: '#report' },
    { label: '事例', href: '#cases' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-[#D0DCF0] shadow-sm' : 'bg-transparent'
      }`}
      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/0873e0011337c9e0296d99f64c28862c/d23467623ddda8d70b1e06cd480d69ba.png"
            alt="KT Partners ロゴ"
            className="h-9 w-auto object-contain transition-all duration-300"
            style={scrolled ? { filter: 'invert(1) brightness(0)' } : {}}
          />
        </a>

        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-[#1A1A2E] hover:text-[#1A5CB0]' : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href={DIAGNOSIS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#0D2B55] text-white text-sm font-medium px-5 py-2 rounded-lg hover:bg-[#1A5CB0] transition-colors cursor-pointer whitespace-nowrap"
          >
            診断ページへ →
          </a>
        </nav>

        <button
          className={`md:hidden p-2 rounded cursor-pointer ${scrolled ? 'text-[#1A1A2E]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#D0DCF0] px-6 py-4 flex flex-col gap-3">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-medium text-[#1A1A2E] hover:text-[#1A5CB0] cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href={DIAGNOSIS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#0D2B55] text-white text-sm font-medium px-5 py-2 rounded-lg text-center cursor-pointer whitespace-nowrap"
          >
            診断ページへ →
          </a>
        </div>
      )}
    </header>
  );
}
